const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
    document.body.removeChild(textArea)
    return true
  } catch (err) {
    document.body.removeChild(textArea)
    return false
  }
}

export const clipboardCopy = async (text) => {
  const escapedText = text.replace('&#60;', '<').replace('&#60;', '<').replace('&#62;', '>')
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(escapedText)
  }

  try {
    await navigator.clipboard.writeText(escapedText)
    return true
  } catch (err) {
    return false
  }
}

export default clipboardCopy
